module.exports = __webpack_public_path__ + "static/EnmTX_BosGodRuneMaster_L_A_cl-87af07424d30b15d5c0dd5f1e659cab8.gif";